<script>
import appConfig from '@src/app.config'
import { mapGetters } from 'vuex'
// Import loading indicator stylesheet
require('vue-loading-overlay/dist/vue-loading.css')
export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
  data() {
    return {
      modalContent: {
        title: 'DELETE',
        content: 'Are you sure you want to delete?',
        headerVariant: 'warning',
        headerTextVariant: 'light',
        eventName: '',
      },
      showModal: false,
      version: appConfig.version,
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUser']),
  },
  methods: {
    setOk() {
      if (this.modalContent.eventName) {
        let _evnts = this.$root.$children[0]._events[
          this.modalContent.eventName
        ]
        if (_evnts.length <= 1) {
          this.$emit(this.modalContent.eventName)
        }
      }
    },
    onCancel(evt) {
      if (evt.trigger !== 'ok') {
        this.$root.$children[0]._events[this.modalContent.eventName] = []
      }
    },
  },
}
</script>

<template>
  <div id="app">
    <div
      id="dev-version-alert"
      class="bg-danger px-5"
      v-if="version === 'v1.0.0'"
    >
      <h6 class="text-white">Development Version</h6>
    </div>
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />

    <!-- global popup -->

    <b-modal
      id="global-modal"
      v-model="showModal"
      :title="modalContent.title"
      :header-bg-variant="modalContent.headerVariant"
      :header-text-variant="modalContent.headerTextVariant"
      @ok="setOk"
      @hide="onCancel"
    >
      <p class="my-3 font-size-18">{{ modalContent.content }}</p>
    </b-modal>
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Design variables and utilities from src/design.
@import '@design';
</style>
